<template>
    <form-modal
        :open="isAddModalOpen"
        :heading="$t('modals.category.add')"
        entity="category"
        mode="add"
        :submit-label="$t('modals.category.save')"
        :fields="fields"
        save-url="/add-category.php"
        :build-payload="buildPayload"
        @update:open="$emit('update:isAddModalOpen', $event)"
        @saved="$emit('category-saved')"
    />
</template>

<script>
import { computed } from 'vue';
import FormModal from '@/components/common/FormModal.vue';
import { t } from '@/i18n';

export default {
    components: {
        FormModal,
    },
    props: {
        isAddModalOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:isAddModalOpen', 'category-saved'],
    setup() {
        const fields = computed(() => [
            { key: 'category_name', label: t('fields.categoryName'), type: 'text', required: true },
        ]);
        const buildPayload = (form) => ({ categoryName: form.category_name });

        return { fields, buildPayload };
    },
};
</script>
